export const shouldOpenSalonPhotoEditor = (search, salonId) => {
  if (salonId === null || salonId === undefined || String(salonId).trim() === '') {
    return false;
  }

  return new URLSearchParams(search || '').get('editPhotos') === 'true';
};

export const focusSalonPhotoSection = (target, onFocused) => {
  if (!target?.scrollIntoView) return false;

  target.scrollIntoView({ block: 'start' });
  onFocused?.();
  return true;
};
